import { Playlist } from '@repo/types'

import { apiClient } from '@/api/api-client'
import StoreService from '@/store/StoreService'

import { useCreatePlaylist } from '../useCreatePlaylist'

export function useCreateUserPlaylist() {
  const { playlistService } = StoreService.getStore()

  const { queryFn, queryKey } = playlistService.queries.userPlaylists

  const mutationFn = (playlist: Playlist) => apiClient.userUpdatePlaylist(playlist)

  return useCreatePlaylist(queryKey, mutationFn, queryFn)
}
